import React, { useState, useEffect, useContext } from "react";
import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory}  from 'react-router-dom';
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import CarHorasSociales from "../element/CarHorasSociales";
import Menu from './Menu';
// Contexto
import dataContext from "../context/User";
// Helper 
import GetFetch from '../helper/GetFetch';
// import ShortData from '../helper/ShortData';
import loadMenu from '../js/main';
import Footer from './Footer';

const HorasSociales = () => {

  const history = useHistory();

  const dataUser = useContext(dataContext);
  let datos = localStorage.getItem('dataUser');
 
  const [horasSociales, setHorasSociales] = useState({});
  const [solvencia, setSolvencia] = useState();
  let ths = 0;

  useEffect(() => {

    if (datos) {
      let cred = JSON.parse(datos);
       dataUser.token = cred.token;
       dataUser.nombre = cred.nombre;
       dataUser.carnet = cred.carnet;
       dataUser.perfil = cred.perfil;
       dataUser.carrera = cred.carrera;

      let horasSocialesAlumno = GetFetch.horasSociales(cred.carnet, cred.token);      
      horasSocialesAlumno.then((dataHoras) => {
        setHorasSociales(dataHoras);
        if(localStorage.getItem('solvencia')){
          setSolvencia('INSOLVENTE')
          setTimeout(() => {
            localStorage.removeItem('solvencia')
          }, 5000);
        }
        });

      loadMenu();
    }else{
      history.push("/"); 
    }
  },[datos, history, dataUser]);

  return (
    // <div>

    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto
            foto={dataUser.carnet}
            alt="Foto alumno"
            tamanio="rounded" />

          <HeaderMenu
            carnet={dataUser.carnet}
            nombre={dataUser.nombre}
            perfil={dataUser.perfil}
            carrera={dataUser.carrera}
            posicion="text-center"
          />

          <Menu />

          <Footer />
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-4 homeLogin"> Horas sociales</h2>
        <p className="text-right">Total de horas sociales: <small id="ths" className="display-4"></small></p>
        {
          horasSociales.length > 0
            ?
            horasSociales.map((element) => {
              ths += element.horas
              document.getElementById('ths').innerHTML = ths
              return (
                <CarHorasSociales
                  datos={element} 
                 />
              )
            })
            :
            solvencia ? <><p className="text-danger display-4">{solvencia}</p></> :
            <p>Horas sociales no realizadas</p>
          }
      </div>
    </div>
  );
};

export default HorasSociales;
